module.exports = __webpack_public_path__ + "static/img/home_bottom_myclass.27853b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_bottom_myclass.png
// module id = 4IHV
// module chunks = 1